export default __webpack_public_path__ + "static/photo_6.png";